import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import swal from 'sweetalert2'

import * as campaignProposalSectionActions from 'agency/redux/modules/campaignProposalSection'

const getExternalLinks = ({ data }) => {
  if (data && data.external_links) return data.external_links
  return []
}

class ProposalSectionWrapper extends React.Component {
  state = {
    editing: false,
  }

  _confirmDelete = () => {
    swal.fire({
      title: 'Delete Section?',
      text: 'Are you sure?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it.',
      confirmButtonColor: '#DD6B55',
      animation: 'slide-from-top',
    }).then(({ value }) => {
      if (value){
        this._deleteSection()
      }
    })
  }

  _deleteSection = () => {
    const { campaignProposalSection, deleteCampaignProposalSection } = this.props
    deleteCampaignProposalSection(campaignProposalSection)
  }

  _createLink = (externalLink) => {
    const { campaignProposalSection } = this.props
    const externalLinks = [...getExternalLinks(campaignProposalSection)]
    externalLinks.push(externalLink)

    this._updateSectionData('external_links', externalLinks)
  }

  _deleteLink = (externalLink) => {
    const { campaignProposalSection } = this.props
    const externalLinks = getExternalLinks(campaignProposalSection).filter(link => link.key !== externalLink.key)

    this._updateSectionData('external_links', externalLinks)
  }

  _updateSectionParam = (name, value) => {
    const { campaignProposalSection: { campaign_proposal_id, id } } = this.props

    const updated = {
      id,
      campaign_proposal_id,
      [name]: value,
    }

    this._updateSection(updated)
  }

  _updateSectionData = (name, value) => {
    const { campaignProposalSection: { campaign_proposal_id, data, id } } = this.props

    const updated = {
      id,
      campaign_proposal_id,
      data: JSON.stringify({
        ...data,
        [name]: value,
      }),
    }

    this._updateSection(updated)
  }

  _updateSection = (section) => {
    const { updateCampaignProposalSection } = this.props
    updateCampaignProposalSection(section)
  }

  _toggleEdit = () => {
    const { editing } = this.state
    const { editingProposal } = this.props

    if (editingProposal){
      this.setState({ editing: !editing })
    }
  }

  render(){
    const { editing } = this.state
    const { campaignProposalSection, editingProposal, render } = this.props

    return render({
      createLink: this._createLink,
      deleteLink: this._deleteLink,
      deleteSection: this._confirmDelete,
      editing,
      editingProposal,
      externalLinks: getExternalLinks(campaignProposalSection),
      section: campaignProposalSection,
      toggleEdit: this._toggleEdit,
      updateSectionData: this._updateSectionData,
      updateSectionParam: this._updateSectionParam,
    })
  }
}

ProposalSectionWrapper.propTypes = {
  campaignProposalSection: PropTypes.object.isRequired,
  deleteCampaignProposalSection: PropTypes.func.isRequired,
  editingProposal: PropTypes.bool,
  render: PropTypes.func.isRequired,
  updateCampaignProposalSection: PropTypes.func.isRequired,
}

function mapStateToProps(){
  return {}
}

const mapDispatchToProps = {
  deleteCampaignProposalSection: campaignProposalSectionActions.deleteCampaignProposalSection,
  updateCampaignProposalSection: campaignProposalSectionActions.updateCampaignProposalSection,
}

export default connect(mapStateToProps, mapDispatchToProps)(ProposalSectionWrapper)
